var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 795,
    height: 438,
    viewBox: "0 0 795 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.55 0C398.74 0 425.39 148.3 436.76 211.64C440.69 233.52 426.14 254.44 404.26 258.37C382.39 262.31 361.45 247.75 357.52 225.87C340.59 131.6 314.06 80.52 222.55 80.52C125.66 80.52 80.52 163 80.52 218.76C80.52 292.15 145.09 356.52 218.71 356.52C240.94 356.52 258.97 374.54 258.97 396.78C258.97 419.02 240.95 437.04 218.71 437.04C100.16 437.02 0 337.06 0 218.75C0 113.55 85.09 0 222.55 0Z",
    fill: "url(#paint0_linear_2_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.48 437.02C395.29 437.02 368.64 288.72 357.27 225.38C353.34 203.5 367.89 182.58 389.77 178.65C411.64 174.71 432.58 189.27 436.51 211.15C453.44 305.42 479.97 356.5 571.48 356.5C668.37 356.5 713.51 274.02 713.51 218.26C713.51 144.87 648.94 80.5 575.32 80.5C553.09 80.5 535.06 62.48 535.06 40.24C535.06 18 553.1 0 575.33 0C693.87 0 794.03 99.96 794.03 218.27C794.03 323.47 708.94 437.02 571.48 437.02Z",
    fill: "url(#paint1_linear_2_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.3 356.1C560.08 356.08 559.85 356.07 559.63 356.05C558.08 355.93 556.52 355.8 554.78 355.63C553.72 355.52 552.62 355.42 551.61 355.29C546.84 354.78 541.46 354.09 535.57 353.13C543.18 354.65 551.41 355.64 560.3 356.09V356.1Z",
    fill: "#00AEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.78 80.96C234.78 80.96 234.83 80.96 234.86 80.96C236.41 81.08 237.96 81.21 239.71 81.38C240.77 81.49 241.88 81.59 242.89 81.72C247.15 82.17 251.97 82.81 257.14 83.61C250.2 82.29 242.76 81.4 234.78 80.95V80.96Z",
    fill: "#00AEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.7 80.33C222.74 80.33 226.47 80.44 230.05 80.62C222.8 80.21 218.7 80.33 218.7 80.33Z",
    fill: "#00AEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.79 356.69C571.75 356.69 568.02 356.58 564.44 356.4C571.69 356.81 575.79 356.69 575.79 356.69Z",
    fill: "#00AEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.57 353.14C472.91 340.62 451.19 292.17 436.74 212.42C436.7 212.15 436.73 211.89 436.68 211.62C434.43 199.08 431.55 183.19 427.06 165.79C365.98 109.05 298.31 90 257.15 83.6C320.76 95.72 342.64 144.31 357.19 224.59C357.23 224.85 357.2 225.11 357.25 225.38C359.46 237.67 362.26 253.19 366.61 270.18L367.32 271.09C427.53 327.08 494.24 346.44 535.58 353.13L535.57 353.14Z",
    fill: "#00AEAD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560.3 356.1C560.08 356.08 559.85 356.07 559.63 356.05C558.08 355.93 556.52 355.8 554.78 355.63C553.72 355.52 552.62 355.42 551.61 355.29C546.84 354.78 541.46 354.09 535.57 353.13C543.18 354.65 551.41 355.64 560.3 356.09V356.1Z",
    fill: "url(#paint2_linear_2_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.78 80.96C234.78 80.96 234.83 80.96 234.86 80.96C236.41 81.08 237.96 81.21 239.71 81.38C240.77 81.49 241.88 81.59 242.89 81.72C247.15 82.17 251.97 82.81 257.14 83.61C250.2 82.29 242.76 81.4 234.78 80.95V80.96Z",
    fill: "url(#paint3_linear_2_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.7 80.33C222.74 80.33 226.47 80.44 230.05 80.62C222.8 80.21 218.7 80.33 218.7 80.33Z",
    fill: "url(#paint4_linear_2_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.79 356.69C571.75 356.69 568.02 356.58 564.44 356.4C571.69 356.81 575.79 356.69 575.79 356.69Z",
    fill: "url(#paint5_linear_2_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.57 353.14C472.91 340.62 451.19 292.17 436.74 212.42C436.7 212.15 436.73 211.89 436.68 211.62C434.43 199.08 431.55 183.19 427.06 165.79C365.98 109.05 298.31 90 257.15 83.6C320.76 95.72 342.64 144.31 357.19 224.59C357.23 224.85 357.2 225.11 357.25 225.38C359.46 237.67 362.26 253.19 366.61 270.18L367.32 271.09C427.53 327.08 494.24 346.44 535.58 353.13L535.57 353.14Z",
    fill: "url(#paint6_linear_2_2)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2",
    x1: 437.4,
    y1: 218.51,
    x2: 0,
    y2: 218.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_2",
    x1: 356.63,
    y1: 218.51,
    x2: 794.03,
    y2: 218.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_2",
    x1: 535.57,
    y1: 354.62,
    x2: 560.3,
    y2: 354.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_2",
    x1: 234.78,
    y1: 82.29,
    x2: 257.15,
    y2: 82.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_2",
    x1: 218.7,
    y1: 80.47,
    x2: 230.05,
    y2: 80.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_2",
    x1: 564.44,
    y1: 356.55,
    x2: 575.79,
    y2: 356.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_2",
    x1: 396.36,
    y1: 346.37,
    x2: 396.36,
    y2: 91.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D7D7D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 794.03,
    height: 437.02,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.3c855e90b3e8de2c1cf77d32515b20af.svg";
export { ForwardRef as ReactComponent };